<template>
  <ul class="hive-dropdown-menu hive-dropdown__content">
    <slot />
  </ul>
</template>

<script>
const name = 'hive-dropdown-menu';
export default {
  name
};
</script>
